module.exports = __webpack_public_path__ + "static/media/Mathew Kurian .af85cca1.jpg";